<template>
	<div>
		<div class="topTitle">发型师营收监测</div>
		<div class="first_line">
			<div class="right_warp">
				<span class="demonstration">月份</span>
				<el-date-picker v-model="filter.month" type="month" placeholder="选择月" size="small"
					value-format="yyyy-MM">
				</el-date-picker>
				<el-select @change="getlist()" v-model="filter.storeId" placeholder="全部门店" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in storeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
					<el-option-group label="结业门店">
						<el-option v-for="item in storeEnd" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-option-group>
				</el-select>
				<el-input v-model="filter.text" placeholder="请输入发型师名称" size="small"
					style="margin-left: 10px;"></el-input>
				<el-select @change="getlist()" v-model="filter.type" placeholder="门店属性" clearable
					style="margin-left: 10px;" size="small">
					<el-option-group label="营业门店" class="store">
						<el-option v-for="item in type" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-option-group>
				</el-select>
				<el-button type="primary" style=" position: relative;margin-left: 10px" @click="getlist()"
					size="small">筛
					选</el-button>
				<el-button class="right" type="primary" size="small" @click="plsc">上传发型师成本</el-button>
				<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
					@change="xuanzhe($event)" />
			</div>
			<el-button type="info" style="dispaly:flex;float:right" size="small" @click="expro()">导出</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="month" label="月份"></el-table-column>
				<el-table-column prop="workerName" label="发型师"></el-table-column>
				<el-table-column prop="storeName" label="门店"></el-table-column>
				<el-table-column prop="totalIncome" label="总营收"></el-table-column>
				<el-table-column prop="newCustomer" label="新客数"></el-table-column>
				<el-table-column prop="meituanCustomer" label="美团单数"></el-table-column>
				<el-table-column prop="douyinCustomer" label="抖音单数"></el-table-column>
				<el-table-column prop="totalCustomer" label="总客数"></el-table-column>
				<el-table-column prop="taocanCustomer" label="套餐数"></el-table-column>
				<el-table-column prop="taocanIncome" label="套餐营收"></el-table-column>
				<el-table-column prop="haircutCustomer" label="剪发单数"></el-table-column>
				<el-table-column prop="colorCustomer" label="染护单数"></el-table-column>
				<el-table-column prop="colorInAll" label="染护占比">
					<template slot-scope="scope">
						{{scope.row.colorInAll?(scope.row.colorInAll*100).toFixed(2):'0'}}%
					</template>
				</el-table-column>
				<el-table-column prop="chengben" label="总成本">
					<template slot-scope="scope">
						{{scope.row.chengben==null?"0":scope.row.chengben}}
					</template>
				</el-table-column>
				<el-table-column prop="yingli" label="利润">
					<template slot-scope="scope">
						<span v-if="scope.row.yingli>0" style="color:limegreen">
							{{scope.row.yingli}}
						</span>
						<span v-else  style="color:red">
							{{scope.row.yingli==null?"0":scope.row.yingli}}
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="lilv" label="产出比">
					<template slot-scope="scope">
						<span v-if="scope.row.lilv>0" style="color:limegreen">
							{{(scope.row.lilv*100).toFixed(2)}}%
						</span>
						<span v-else style="color:red">
							{{scope.row.lilv==null?"0":(scope.row.lilv*100).toFixed(2)}}%
						</span>
						<!-- {{scope.row.lilv==null?"0":scope.row.lilv}}% -->
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	import  {url,format}  from "../../../utils/index.js"
	import {export2Excel} from '../../../common/js/util'
	export default {
		data() {
			return {
				tableData: [],
				filter: {
					month: new Date().getFullYear() + '-' + (new Date().getMonth() < 10 ?'0'+( new Date().getMonth() + 1) :
						new Date().getMonth() + 1),
					storeId: "",
					workerName: "",
				},
				storeEnd: [],
				storeList: [],
				type: [{
						value: 1,
						label: "直营店"
					},
					{
						value: 6,
						label: "加盟店"
					}
				],
				columns: [{
					title: '月份',
					key: 'month'
				}, {
					title: '发型师',
					key: 'workerName'
				}, {
					title: '门店',
					key: 'storeName'
				}, {
					title: '总营收',
					key: 'totalIncome'
				}, {
					title: '新客数',
					key: 'newCustomer'
				}, {
					title: '美团单数',
					key: 'meituanCustomer'
				}, {
					title: '抖音单数',
					key: 'douyinCustomer'
				}, {
					title: '总客数',
					key: 'totalCustomer'
				}, {
					title: '套餐数',
					key: 'taocanCustomer'
				}, {
					title: '套餐营收',
					key: 'taocanIncome'
				}, {
					title: '剪发单数',
					key: 'haircutCustomer'
				}, {
					title: '染护单数',
					key: 'colorCustomer'
				}, {
					title: '染护占比(%)',
					key: 'colorInAll'
				}, {
					title: '总成本',
					key: 'chengben'
				}, {
					title: '利润',
					key: 'yingli'
				}, {
					title: '产出比(%)',
					key: 'lilv'
				}]
			};
		},
		mounted() {
			this.getStores()
			this.getlist()
		},
		methods: {
			// 获取门店列表
			getStores() {
				this.$http.get("store/list").then(res => {
					res.body.data.forEach(ele => {
						if (ele.businessType == 1) {
							this.storeEnd.push(ele) //结业门店
						} else {
							this.storeList.push(ele) //营业门店
						}
					})
				})
			},
			getlist() {
				var a = "?month=" + this.filter.month
				if (this.filter.storeId) {
					a = a + "&storeId=" + this.filter.storeId
				}
				if (this.filter.type) {
					a = a + "&type=" + this.filter.type
				}
				//发型师名称
				if (this.filter.text) {
					a = a + "&text=" + this.filter.text
				}
				this.$http.get("data/workerRevenueData" + a).then(
					function(res) {
						this.tableData = res.body.data
						this.tableData.map(ele=>{
							ele.colorInAll = ele.colorInAll/100
							ele.lilv =  ele.lilv/100
						})
					},
					function(err) {
						this.$message.error("请求失败")
					})
			},
			expro() {
				this.tableData.forEach(ele => {
					if (ele.colorInAll == null) {
						ele.colorInAll = 0
					}
					// if(ele.chengben ==null){
					// 	ele.chengben = 0
					// }
					// if(ele.yingli ==null){
					// 	ele.yingli = 0
					// }
					// if(ele.lilv ==null){
					// 	ele.lilv = 0
					// }
				})
				export2Excel(this.columns, this.tableData)
			},
			// 文件上传
			plsc: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				var that = this
				this.$http.post("dWorkerCost/add", Formdata, config).then(function(
					res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						this.getList()
					} else {
						this.$message.error(res.body.msg)
					}
					var t = setTimeout(function() {
						console.log("刷新页面")
						that.reload()
					}, 4000);
				})
			},
		}
	};
</script>
<style lang="less" scoped>
	.topTitle {
		font-weight: blod;
		font-size: 22px;
		color: #707070;
	}

	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}
	
	/deep/.el-select-dropdown__item {
		width:220px;
	}
</style>